import React from "react";
// import React, { useState, useEffect } from "react";
// import { Link, useLocation } from "wouter";
export default function Home() {


return (
    <>  
        <title>Grimm's Corner</title>
        <main id="main" className="">
            
        </main>
    </>

    );
}